export default __webpack_public_path__ + "static/media/SF_logo.575cbf0a.svg";